<template>
  <div class="user">
  <v-container>
    <v-layout row wrap v-if="user">
      <!-- description -->
      <v-flex mt-4 ml-4 xs12 class="grey--text text--darken-1"> 
        <h1 class="heading">User Console</h1>
      </v-flex>
      <v-flex pa-4 xs12 sm6 class="grey--text text--darken-1"> 
        <v-card flat class="mr-5 my-3 pa-2 grey--text text--darken-3" v-if="user">
          <v-card-text class="grey--text text--darken-3 mx-auto">
                <div v-if="!preaceptedTerms && email==null "  class="grey--text text--darken-3 mx-auto"> 
                  <h2 class="grey--text text--darken-3 mb-4"> Want to log in without Telegram?</h2> 
                  <p> Register your email! You'll also be able to subscribe to our newsletter for project updates, and in the near future, set up alerts for your ground station.</p> 
                </div>




                          <template>
            <div>
              <v-btn  color="primary" @click="dialog = true">e-mail</v-btn>
              <v-dialog v-model="dialog" persistent max-width="600px">
                <v-card>
                  <v-card-title>
                    <span class="headline">e-mail preferences</span>
                  </v-card-title>
                  <v-card-text>
                    <p>Adding your email will allow to control your stations even without Telegram Access:</p>
                    <v-form v-model="valid" ref="form">
                      <v-text-field
                        v-model="email" 
                        label="E-mail"
                        :rules="emailRules"
                        required
                        :color="emailValidated ? 'green' : null"
                        :append-icon="emailValidated && email==preEmail ? 'mdi-check-circle' : null"

                      ></v-text-field>
                      <div v-if="emailValidated && email==preEmail" class="green--text mt-4">Validated email</div>
                      <div v-if="!preaceptedTerms" class="mt-4">
                      <input type="checkbox" id="acceptTerms" v-model="acceptedTerms">
                      <label for="acceptTerms"> I accept the <a href="/terms" target="_blank">terms and conditions</a>.</label>
                      </div>
                      <div v-if="!acceptedTerms" class="red--text mt-2">You must accept the terms and conditions.</div>

                      <div class="mt-4">
                        <p>Subscribe to the tinyGS newsletter:</p>
                        <v-radio-group v-model="newsletterFrequency" row>
                          <!-- <v-radio label="Daily" value="daily"></v-radio> -->
                          <v-radio label="Daily" value="daily"></v-radio>
                          <v-radio label="Weekly" value="weekly"></v-radio>
                          <v-radio label="None" value="none"></v-radio>
                        </v-radio-group>
                      </div>
                    </v-form>

                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">
                      Cancel
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="submit"
                      :disabled="!valid || !acceptedTerms"
                    >
                      Save
                    </v-btn>
                  </v-card-actions>
                </v-card>
                </v-dialog>
            </div>
          </template>

          <div v-if="!emailValidated && preaceptedTerms"  class="red--text mt-2">  Please check your mailbox and validate the email.</div>
          </v-card-text>
        </v-card>
      </v-flex>
      <!-- Stations -->
      <v-flex xs12 sm12 pa-4>
        <div v-for="station in stations" :key="`${station.name}@${station.userId}`"> 
          <Station :station="station"/>
          <v-divider></v-divider>
        </div>
      </v-flex>
    </v-layout>
    <v-row v-else class="fill-height ma-0" align="center" justify="center">
      <v-progress-circular indeterminate color="grey"></v-progress-circular>
    </v-row>
  </v-container>
</div>

</template>

<script>
const axios = require("axios");
import Station from '../components/Station.vue'

export default {
  components: {
    Station
  },
  data() {
    return {
      user: false,
      stations: null,
      dialog: false,
      email: null,
      emailValidated: false,
      preEmail: null,
      valid: true,
      acceptedTerms: false,
      preaceptedTerms: false,
      newsletterFrequency: 'none', // Default value
      sending: false,
      saveError: false,
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      newsletterRules: [
        v => !!v || 'Please select a newsletter frequency.', // Regla principal
      ],
    }
  },
  beforeMount(){  
    this.getStations()
    this.getUser()
  },
  methods:{
    async getStations() {
      if (!localStorage.userId)
        return;

      const { data } = await axios.get(`${process.env.VUE_APP_API_ENDPOINT}/v1/stations?userId=${localStorage.userId}`);
      console.log(data);
      this.stations = data;
  //    const { user } = await axios.get(`${process.env.VUE_APP_API_ENDPOINT}/v1/user?userId=${localStorage.userId}`);
 //     console.log(user);
  //    this.user = user;
    },
    async getUser() {
  // Verificar si tenemos userId y sessionToken en localStorage
  if (!localStorage.userId || !localStorage.sessionToken) {
    console.warn("userId o sessionToken no encontrados en localStorage.");
    this.user = false; // Asegurarse de que el estado del usuario se actualice si falta algo
    return;
  }

  this.user = true; // Marcar que tenemos un userId (potencialmente válido)

  // Construir el objeto de configuración solo con los headers
  const config = {
    headers: {
      sessionToken: localStorage.sessionToken,
      userId: localStorage.userId // Puedes mantenerlo si tu API lo espera en el header también
      // Considera si realmente necesitas enviar userId tanto en la query como en el header.
      // Si la API solo lo necesita en uno de los dos sitios, envíalo solo allí.
    }
  };

  // La URL ya contiene el parámetro userId
  const url = `${process.env.VUE_APP_API_ENDPOINT}/v1/user?userId=${localStorage.userId}`;

  try {
    // Pasar la URL y el objeto config como segundo argumento
    const { data } = await axios.get(url, config);

    console.log("Datos recibidos:", data); // Es buena idea loguear lo que recibes

    // Asignaciones más seguras por si alguna propiedad no viene en la respuesta
    this.preEmail = data.email || "";
    this.email = data.email || "";
    this.newsletterFrequency = data.newsletterFrequency || 'none';
    this.preaceptedTerms = data.acceptedTerms || false;
    this.acceptedTerms = data.acceptedTerms || false;
    this.emailValidated = data.emailVal || false;

  } catch (error) {
    console.error("Error al obtener datos del usuario:", error.response || error.message || error);
    // Aquí podrías manejar el error, por ejemplo, limpiando localStorage si el token es inválido
    // o mostrando un mensaje al usuario.
    // Ejemplo: if (error.response && error.response.status === 401) { /* limpiar sesión */ }
    this.user = false; // Marcar que la obtención falló
  }
},

    async submit() {
      if (this.$refs.form.validate()) {

        let params = {
        email: this.email.replace(/<[^>]+>/g, ''),
        acceptedTerms: this.acceptedTerms,
        newsletterFrequency : this.newsletterFrequency,
	
      }
      let config = {
        headers: {
          sessionToken: localStorage.sessionToken,
          userId: localStorage.userId
        }
      }
      this.sending = true

      try {
        await axios.put(`${process.env.VUE_APP_API_ENDPOINT}/v1/user/${this.$route.params.id}`, params, config);
      } catch (err) {
        console.log(JSON.stringify(err))
        this.saveError = true
        this.sending = false
        return
      }
      this.$emit("configSaved", params);





        // Perform your logic here, e.g., send the email to a server
        console.log('Email submitted:', this.email);
        this.dialog = false;
        //this.$refs.form.reset(); // Clear the form after submission
        //this.email=null;
        //this.acceptedTerms=false;
        //this.newsletterFrequency='none';
        alert("Config saved!");


      }
    },
    close() {
      this.dialog = false;
     // this.$refs.form.reset(); // Clear the form if the dialog is closed
        //this.email=null;
     //   this.acceptedTerms=false;
     //   this.newsletterFrequency='none';
    },
  }
}
</script>

<style>

</style>